import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  //gap: 52px;\n  padding: 41px 0;\n  @media (max-width: 1200px) {\n    //gap: 42px;\n  }\n  @media (max-width: 768px) {\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-top: 72px;\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n    width: 308px;\n    height: 32px;\n    margin-bottom: 20px;\n  }\n  .list-item-image > div {\n    height: 100%;\n  }\n  .list-wrapper {\n    display: flex;\n    margin-top: 16px;\n    gap: 16px;\n    .list-item {\n      flex-direction: column;\n      width: 420px;\n      height: 382px;\n      display: flex;\n      gap: 20px;\n      .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n        width: 224px;\n        height: 224px;\n        border-radius: 6px;\n      }\n      .contents {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n          width: 220px;\n          height: 26px;\n\n          &:nth-child(2) {\n            width: 26px;\n          }\n        }\n      }\n    }\n  }\n  @media (max-width: 768px) {\n    .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n      width: 150px;\n      height: 150px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 52px;\n  margin-top: 40px;\n  .contents {\n    display: flex;\n    align-items: center;\n    gap: 28px;\n    max-width: 1200px;\n    overflow: hidden;\n\n    > div {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  @media (max-width: 1200px) {\n    margin-bottom: 40px;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 32px;\n    margin-top: 24px;\n    gap: 16px;\n    .contents {\n      height: 153px;\n      gap: 12px;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-input,\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n    border-radius: 6px;\n    //background-color: dddd;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 50px;\n  @media (max-width: 1200px) {\n    margin-bottom: 42px;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 32px;\n  }\n  .ant-skeleton.ant-skeleton-element {\n    width: 100%;\n  }\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n    width: 100%;\n    height: 180px;\n    @media (max-width: 1200px) {\n      aspect-ratio: 1100/210;\n      max-height: 210px;\n      max-width: 1200px;\n      width: 100%;\n      height: 100%;\n    }\n    @media (max-width: 768px) {\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 72px;\n  overflow: hidden;\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n    width: 352px;\n    height: 32px;\n  }\n  .button-wrapper {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n    .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n      width: 80px;\n      height: 40px;\n    }\n  }\n  .list-wrapper {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    /* row-gap: 28px; */\n    /* column-gap: 36px; */\n    gap: 36px 32px;\n    margin-top: 20px;\n    .list-item {\n      width: 376px;\n      height: 172px;\n      display: flex;\n      overflow: hidden;\n      gap: 16px;\n      .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n        border-radius: 6px;\n        width: 136px;\n        height: 100%;\n      }\n      .contents {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n          height: 32px;\n        }\n      }\n    }\n    @media (max-width: 768px) {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 38px;\n    .button-wrapper {\n      margin-top: 16px;\n      .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n        height: 30px;\n        width: 68px;\n      }\n    }\n    .list-wrapper {\n      column-gap: 20px;\n      row-gap: 20px;\n      margin-top: 16px;\n      .list-item {\n        width: 320px;\n        height: 126px;\n        gap: 12px;\n        .ant-skeleton.ant-skeleton-element .ant-skeleton-avatar {\n          width: 108px;\n        }\n        .contents {\n          .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n            height: 22px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  flex: 1 1 auto;\n  margin-bottom: 72px;\n  .ant-skeleton.ant-skeleton-element {\n    width: 100%;\n    flex: 1 1 auto;\n  }\n  .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n    width: 100%;\n    height: 104px;\n    display: flex;\n    flex: 1 1 auto;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 38px;\n    overflow: hidden;\n    .ant-skeleton.ant-skeleton-element .ant-skeleton-button {\n      width: 280px;\n      height: 74px;\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Skeleton } from "antd";
import styled from "styled-components";
const MainPageSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-0"
})(_templateObject());
export const MainPageSkeleton = ()=>{
    return /*#__PURE__*/ _jsxs(MainPageSkeletonWrapper, {
        children: [
            /*#__PURE__*/ _jsx(MainBannerSkeleton, {}),
            /*#__PURE__*/ _jsx(MainBannerSkeleton, {}),
            /*#__PURE__*/ _jsx(SelectedBooksSectionSkeleton, {}),
            /*#__PURE__*/ _jsx(SolvookPassOnlySkeleton, {}),
            /*#__PURE__*/ _jsx(RankingListSkeleton, {}),
            /*#__PURE__*/ _jsx(MiniBannerSkeleton, {}),
            /*#__PURE__*/ _jsx(ManualCurationSkeleton, {})
        ]
    });
};
export const MainBannerSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(StyledSkeleton, {
        children: /*#__PURE__*/ _jsx(MainBannerSkeletonWrapper, {
            children: /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                active: true,
                shape: "square"
            })
        })
    });
};
export const MiniBannerSkeleton = ()=>{
    return /*#__PURE__*/ _jsx(StyledSkeleton, {
        children: /*#__PURE__*/ _jsxs(MiniBannerSkeletonWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Skeleton.Button, {
                    active: true
                }),
                /*#__PURE__*/ _jsx(Skeleton.Button, {
                    active: true
                }),
                /*#__PURE__*/ _jsx(Skeleton.Button, {
                    active: true
                })
            ]
        })
    });
};
const SolvookPassOnlySkeleton = ()=>{
    const { width  } = useWindowDimensions();
    const isMobile = width < 769;
    return /*#__PURE__*/ _jsx("div", {
        style: {
            marginBottom: 40
        },
        children: /*#__PURE__*/ _jsx(StyledSkeleton, {
            children: /*#__PURE__*/ _jsxs(ManualCurationSkeletonWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton.Input, {}),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "list-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "list-item-image list-item",
                                children: /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                                    shape: "square",
                                    active: true,
                                    style: {
                                        height: "100%"
                                    }
                                })
                            }),
                            Array.from({
                                length: 4
                            }).map((item, index)=>{
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "list-item",
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                                            shape: "square",
                                            active: true
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                    active: true
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                    style: {
                                                        width: isMobile ? "100px" : "130px"
                                                    },
                                                    active: true
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                    style: {
                                                        width: isMobile ? "80px" : "100px"
                                                    },
                                                    active: true
                                                })
                                            ]
                                        })
                                    ]
                                }, "manual-curation-skeleton-".concat(index));
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export const RankingListSkeleton = ()=>{
    const { width  } = useWindowDimensions();
    const isMobile = width < 769;
    return /*#__PURE__*/ _jsx(StyledSkeleton, {
        children: /*#__PURE__*/ _jsxs(RankingSectionSkeletonWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Skeleton.Input, {}),
                /*#__PURE__*/ _jsxs("div", {
                    className: "button-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                            active: true
                        }),
                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                            active: true
                        }),
                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                            active: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "list-wrapper",
                    children: Array.from({
                        length: isMobile ? 3 : 12
                    }).map((item, index)=>{
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "list-item",
                            children: [
                                /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                                    shape: "square",
                                    active: true
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "contents",
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            active: true,
                                            style: {
                                                width: isMobile ? "120px" : "150px"
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            style: {
                                                width: isMobile ? "200px" : "260px"
                                            },
                                            active: true
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            style: {
                                                width: isMobile ? "100px" : "130px"
                                            },
                                            active: true
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            style: {
                                                width: isMobile ? "80px" : "100px"
                                            },
                                            active: true
                                        })
                                    ]
                                })
                            ]
                        }, "ranking-list-skeleton-".concat(index));
                    })
                })
            ]
        })
    });
};
export const SelectedBooksSectionSkeleton = ()=>{
    const active = true;
    const size = "default";
    const { width  } = useWindowDimensions();
    const isMobile = width < 769;
    return /*#__PURE__*/ _jsx(StyledSkeleton, {
        children: /*#__PURE__*/ _jsxs(SelectedBooksSectionSkeletonWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Skeleton.Input, {
                    active: true,
                    size: size,
                    style: {
                        height: isMobile ? "24px" : "32px",
                        width: isMobile ? "224px" : "336px"
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "contents",
                    children: Array.from({
                        length: 8
                    }).map((item, idx)=>{
                        return /*#__PURE__*/ _jsxs("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                gap: 12,
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Skeleton.Input, {
                                    active: true,
                                    style: {
                                        width: 34,
                                        minWidth: 34,
                                        height: 48
                                    }
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            style: {
                                                width: 124,
                                                minWidth: 34,
                                                height: 16
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            style: {
                                                width: 124,
                                                minWidth: 34,
                                                height: 16
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, "selected-books-skeleton-".concat(idx));
                    })
                })
            ]
        })
    });
};
const ManualCurationSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-1"
})(_templateObject1());
export const ManualCurationSkeleton = ()=>{
    const { width  } = useWindowDimensions();
    const isMobile = width < 769;
    return /*#__PURE__*/ _jsx(StyledSkeleton, {
        children: /*#__PURE__*/ _jsxs(ManualCurationSkeletonWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Skeleton.Input, {}),
                /*#__PURE__*/ _jsx("div", {
                    className: "list-wrapper",
                    children: Array.from({
                        length: 5
                    }).map((item, index)=>{
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "list-item",
                            children: [
                                /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                                    shape: "square",
                                    active: true
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "contents",
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            active: true
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            style: {
                                                width: isMobile ? "100px" : "130px"
                                            },
                                            active: true
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                            style: {
                                                width: isMobile ? "80px" : "100px"
                                            },
                                            active: true
                                        })
                                    ]
                                })
                            ]
                        }, "manual-curation-skeleton-".concat(index));
                    })
                })
            ]
        })
    });
};
export const SelectedBooksSectionSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-2"
})(_templateObject2());
export const StyledSkeleton = styled.div.withConfig({
    componentId: "sc-98575d1c-3"
})(_templateObject3());
const MainBannerSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-4"
})(_templateObject4());
const RankingSectionSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-5"
})(_templateObject5());
const MiniBannerSkeletonWrapper = styled.div.withConfig({
    componentId: "sc-98575d1c-6"
})(_templateObject6());
